import React from "react";
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import { Controller } from "react-hook-form";

const DropDown = ({
      items,
      formMethods,
      id,
      label,
      options,
      disabled = false,
      defaultValue = "",
  }) => {
    const { control } = formMethods;
    const isRequired = options?.required !== undefined && options.required !== false;

    const menuItems = React.useMemo(
        () => Array.from(Object.entries(items)),
        [items]
    );

    return (
        <Controller
            name={id}
            control={control}
            defaultValue={defaultValue}
            rules={options}
            render={({ field, fieldState }) => (
                <FormControl
                    fullWidth
                    disabled={disabled}
                    error={!!fieldState.error}
                >
                    <InputLabel>{label}</InputLabel>

                    <Select
                        {...field}  // value, onChange, onBlur, ref, name
                        label={label}
                        fullWidth
                        sx={{backgroundColor: "white" }}
                    >
                        {!isRequired && (
                            <MenuItem key="clear" value="">Ryd valg</MenuItem>
                        )}

                        {menuItems.map(([key, value]) => (
                            <MenuItem key={key} value={value}>
                                {key}
                            </MenuItem>
                        ))}
                    </Select>

                    <FormHelperText sx={{ m: "3px 0 0 0" }}>
                        {fieldState.error?.message}
                    </FormHelperText>
                </FormControl>
            )}
        />
    );
};

export default DropDown;
